module.exports = __webpack_public_path__ + "assets/favicons/favicon-16x16.png";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=assets/favicons/[name].[ext]!./src/assets/favicons/favicon-16x16.png
// module id = yVpz
// module chunks = 1